import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { loadSkills } from './skillTree';
import { loadProjects } from './projectShowcase';

const root = ReactDOM.createRoot(document.getElementById('root'));

(async () => {
  await Promise.all([
    loadSkills('/data/skills.json'),
    loadProjects('/data/projects.json')
  ]);

  root.render(
    <App />
  );
})();